export const authenticationRoutePaths = {
  forgotPassword: '/forgot-password',
  login: '/login',
  register: '/register',
  resetPassword: '/reset-password',
  startFirm: '/start-firm',
} as const;

const authenticationPathnames = new Set<string>(Object.values(authenticationRoutePaths));

export function isAuthenticationPath(pathname: string): boolean {
  return authenticationPathnames.has(pathname);
}
